export enum BusinessModule {
  DELEGATIONS = 'delegations',
  DRIVERS = 'drivers',
  FLEET = 'fleet',
  BASES = 'bases',
  FUEL_POLICY = 'fuelPolicy',
  ROUTE_COSTS_AND_PREFERENCES = 'routeCostsAndPreferences',
  ENGINE_CONFIG = 'engineConfig',
  INTEGRATIONS = 'integrations',
}
